import baseTheme from '../baseTheme';
var MuiListItemText = {
    root: {
        marginTop: 0,
        marginBottom: 0,
    },
    multiline: {
        marginTop: 0,
        marginBottom: 0,
    },
    primary: {
        marginBottom: 'auto',
    },
    secondary: {
        color: baseTheme.palette.text.primary,
        marginBottom: 'auto',
    },
};
export default MuiListItemText;
//# sourceMappingURL=MuiListItemText.js.map